<template>
  <div class="pd-24" :class="{'col-xs-12 col-sm-6 col-md-4' : widgetTrackplusFlag}">
    <div class="expiry_pending" :class="widgetTrackplusFlag ? 'widget' : ''">
      <h3 class="title">
        <img src="/static/images/icons/track_plus_icon_blue.svg" v-if="panel && panel.active" class="track_plus_icon_blue" />
        <span
          :class="{'pl-19': panel && panel.active}"
          class="cursor-pointer"
          @click="goToLink"
          >Pending</span
        >
      </h3>
      <div class="MT-25">
        <div v-for="(item, key, index) in pending_summary" :key="index">
          <p class="tab_expiry">
            <span v-if="key === 'initial'">Initial Registrations</span>
            <span v-if="key === 'modification'">Modifications</span>
            <span v-if="key === 'renewal'">Renewals</span>
            <el-popover
              placement="bottom"
              popper-class="popper-custom-class"
              width="200"
              trigger="hover"
              v-model="pendingVisible[index]"
              v-if="item.products && item.products.length > 0"
              :disabled="openPopover"
              @hide="$parent.hidePopover"
            >
              <div class="popper-height">
                <p
                  class="cursor-pointer"
                  v-for="(penReg, index) in item.products"
                  :key="index"
                  @click="$emit('viewRegistration', penReg.rid, 'pending', index)"
                >{{penReg.name}}</p>
              </div>
              <!-- <template #reference> -->
                <span
                  class="progress_count cursor-pointer"
                  @click="$parent.activatePopover"
                  slot="reference"
                >{{item.number}}</span>
              <!-- </template> -->
            </el-popover>
            <span class="progress_count" v-if="item.products.length === 0">{{
              item.number
            }}</span>
          </p>
          <div class="progress">
            <div
              class="progress-bar"
              :class="{
                green: key === 'initial',
                orange: key === 'modification',
                blue: key === 'renewal',
              }"
              :aria-valuenow="item.number"
              :aria-valuemin="0"
              :aria-valuemax="100"
              :style="{ width: item.number + '%' }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Popover } from 'element-ui';
// import BasePopover from '../Common/BasePopover.vue';

export default {
  components: {
    // BasePopover,
    'el-popover': Popover,
  },
  props: ['widgetTrackplusFlag', 'pending_summary', 'pendingVisible', 'openPopover', 'panel', 'isCombo'],
  data() {
    return {};
  },
  methods: {
    goToLink() {
      this.$router.push({
        name: 'Registration',
        params: { filterRegistration: 'Pending' },
      });
    },
    viewRegistration(registrationId, type, index) {
      this.$emit('viewRegistration', registrationId, type, index);
    },
  },
};
</script>

<style scoped>
.widget {
  min-height: 280px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.27);
  border-radius: 10px;
  padding: 20px 24px 24px 24px;
  background: #ffffff;
}
.dashboard-trackplus-cards .title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #0B3C61;
}
.pl-19 {
  padding-left: 19px;
}
.dashboard-trackplus-cards .track_plus_icon_blue {
  width: 32px;
  height: 32px;
}
.dashboard-trackplus-cards .MT-12 {
  margin-top: 12px;
}

.dashboard-trackplus-cards .pd-24{
  padding: 24px;
}
.dashboard-trackplus-cards .pd-tp-0{
  padding-top: 0px !important;
}
.dashboard-trackplus-cards .expiry_pending .tab_expiry {
  line-height: 13px;
}
.dashboard-trackplus-cards .expiry_pending h3 {
  line-height: 33px;
}
.MT-25 {
  margin-top: 25px;
}
.expiry_pending h3 {
  margin: 0;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #0B3C61;
}
.expiry_pending .tab_expiry {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 12px;
  margin-bottom: 6px;
}
.expiry_pending .progress_count {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  float: right;
}
.expiry_pending .green {
  background: #4C9E45;
}
.expiry_pending .orange {
  background: #F2994A;
}
.expiry_pending .blue {
  background: #2F80ED;
}
.expiry_pending .red {
  background: #CF5F28;
}
.expiry_pending .progress {
  height: 11px;
  margin-bottom: 0;
  background: #C4C4C4;
  box-shadow: none;
  border-radius: 8px;
}
.cursor-pointer {
  cursor: pointer !important;
  word-break: break-all;
  white-space: normal;
}
@media screen and (max-width: 991px) {
  .content-wrappper .widget {
    margin-top: 20px !important;
  }
}
</style>
